module.exports = __webpack_public_path__ + "static/media/full_banner.3f11d53f.png";